import styled from '@emotion/styled'
import IconLasso from 'src/assets/images/ic_lasso.svg'
import IconLassoActive from 'src/assets/images/ic_lasso_active.svg'
import { zIndex } from 'src/constants/zIndex'

interface Props {
    active: boolean
    onToggle: () => void
}

export function ToggleLassoButton({ active, onToggle }: Props) {
    return (
        <LassoButton
            data-testid='vmap-toggle-lassoButton'
            src={active ? IconLassoActive : IconLasso}
            onClick={onToggle}
            height={48}
            width={48}
        />
    )
}

// Placed right above the visible areas button
const LassoButton = styled.img`
    position: absolute;
    z-index: ${zIndex.medium};
    right: 4px;
    bottom: 86px;
    cursor: pointer;
`
